import { FunnelX, Plus, Route } from "lucide-react";

import { useNavigation } from "@/providers";
import { TimelineMessage } from "@/shared/components/Timeline";
import { RobotoButton } from "@/shared/foundation/primitives";

interface NoSessionsProps {
  /** Whether filters are applied, so the way out is clearing them rather than creating a session. */
  filtered: boolean;
  /** How many matching sessions have no time range; they are in the tray below. */
  untimedCount: number;
  onClearFilters: () => void;
}

/** The timeline's `empty` slot: why no session is on it, and the way to get one there. */
export function NoSessions({
  filtered,
  untimedCount,
  onClearFilters,
}: NoSessionsProps) {
  const { goto } = useNavigation();
  const title = titleOf(filtered, untimedCount);
  return (
    <TimelineMessage
      icon={
        filtered ? <FunnelX aria-hidden="true" /> : <Route aria-hidden="true" />
      }
      title={title}
      description={
        !filtered && untimedCount === 0
          ? "Sessions mark a flight, drive or run so you can find and replay it later."
          : undefined
      }
      action={
        filtered ? (
          <RobotoButton variant="secondary" onClick={onClearFilters}>
            Clear filters
          </RobotoButton>
        ) : (
          <RobotoButton
            variant="primary"
            icon={<Plus aria-hidden="true" />}
            // TODO(ENG-3298): start the flow with this device filled in. The
            // create-session page takes only a dataset today (`dataset_id`).
            onClick={() => goto.createSession()}
          >
            New session
          </RobotoButton>
        )
      }
    />
  );
}

function titleOf(filtered: boolean, untimedCount: number): string {
  if (untimedCount > 0) {
    // The tray under the timeline lists them.
    return "No sessions with a time range yet";
  }
  return filtered ? "No sessions match these filters" : "No sessions yet";
}
